import { HeadingsP08, SectionP08 } from '../IntendendComponents';

const Prac08 = () => {
  return (
    <SectionP08>
      <HeadingsP08>Title</HeadingsP08>
      <SectionP08>
        <HeadingsP08>Heading</HeadingsP08>
        <HeadingsP08>Heading</HeadingsP08>
        <HeadingsP08>Heading</HeadingsP08>
        <SectionP08>
          <HeadingsP08>Sub-heading</HeadingsP08>
          <HeadingsP08>Sub-heading</HeadingsP08>
          <HeadingsP08>Sub-heading</HeadingsP08>
          <SectionP08>
            <HeadingsP08>Sub-sub-heading</HeadingsP08>
            <HeadingsP08>Sub-sub-heading</HeadingsP08>
            <HeadingsP08>Sub-sub-heading</HeadingsP08>
          </SectionP08>
        </SectionP08>
      </SectionP08>
    </SectionP08>
  );
};

export default Prac08;
